import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

// The shared demo brand for the framework example apps (React now; Angular, Vue,
// Svelte, … later). One brand so every example looks identical and there is a
// single place to change the demo colours, fonts, logo, and identity.
//
// The example apps pass this brand to the SDK as `config.theme` (the SDK themes
// only from `config.theme`, never from the API), so brand.json is the single
// source of truth for their look, the Studio preview, and email theming.
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "8cffaf2d-26d2-4c84-bb1d-3f417e0cb8c1",
  title: "Coras",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-IE",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [],
  logo: "/assets/images/logo.svg",
  domain: "react.coras.io",
  detectLocale: true,
  detectCurrency: true,
};
